import { axios, handleError } from '../axios';

export const getPost = (id, group) => {
  return new Promise((resolve, reject) => {
    axios
      .get('post/', {
        params: {
          p: id,
          g: group,
        },
      })
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
